import { render, staticRenderFns } from "./RecruiterAiInterviewReport.vue?vue&type=template&id=382c4fbc&scoped=true"
import script from "./RecruiterAiInterviewReport.vue?vue&type=script&lang=ts"
export * from "./RecruiterAiInterviewReport.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterAiInterviewReport.vue?vue&type=style&index=0&id=382c4fbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382c4fbc",
  null
  
)

export default component.exports